<img
  ngSrc="images/logo512.webp"
  [width]="size"
  [height]="size"
  alt="{{appname}} Logo"
/>
